module.exports = __webpack_public_path__ + "img/icon_best_prize.bca0408c.png";